import { render, staticRenderFns } from "./NewContentThree.vue?vue&type=template&id=a4d46008&"
import script from "./NewContentThree.vue?vue&type=script&lang=js&"
export * from "./NewContentThree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4d46008')) {
      api.createRecord('a4d46008', component.options)
    } else {
      api.reload('a4d46008', component.options)
    }
    module.hot.accept("./NewContentThree.vue?vue&type=template&id=a4d46008&", function () {
      api.rerender('a4d46008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/contents/NewContentThree.vue"
export default component.exports